import { Box, Button, Divider, Fade, IconButton, Modal, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import CustomTextInput from '../../../components/CustomTextInput';
import { yupResolver } from '@hookform/resolvers/yup';
import { NotesValidationSchema } from '../../../validations/LineItemValidation';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '500px',
  bgcolor: 'background.paper',
  borderRadius: '15px',
  boxShadow: 24,
};

export default function AddNotesPopup({ open, onClose, readOnly = false, addNotes, initialData = {} }) {
  const {
    handleSubmit,
    control,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(NotesValidationSchema),
    defaultValues: {
      notes: '',
    },
  });

  useEffect(() => {
    if (open) {
      reset({
        notes: initialData?.notes || '',
      });
    }
  }, [initialData, open, reset]);

  const handleFormSubmit = (data) => {
    addNotes(data);
    onClose();
    reset();
  };

  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      className={'backdrop-model'}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 2,
              py: 2,
              borderBottom: '1px solid #e0e0e0',
            }}
          >
            <Typography variant="h6">Notes</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider />
          <Box sx={{ p: 2 }}>
            <Stack spacing={2}>
              <CustomTextInput
                name="notes"
                label="Add notes here"
                control={control}
                errors={errors}
                readOnly={readOnly}
                multiline
                rows={5}
              />
            </Stack>
            <Stack alignItems="flex-end">
              <Typography variant="caption" color="textSecondary">
                {watch('notes')?.length || 0}/1000
              </Typography>
            </Stack>
          </Box>
          <Divider />
          <Box
            sx={{
              px: 2,
              py: 1,
              borderTop: '1px solid #e0e0e0',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1,
            }}
          >
            <Button type="button" variant="contained" color="primary" onClick={handleSubmit(handleFormSubmit)}>
              Add Notes
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
